// extracted by mini-css-extract-plugin
module.exports = {"workshops":"FourImageCollage_workshops__DUIxv","heading":"FourImageCollage_heading__6bCf5","grid":"FourImageCollage_grid__OFlkB","card":"FourImageCollage_card__EQXQE"};